import React, { Fragment, useEffect, useState } from 'react';
import { Row, Table, Button } from 'reactstrap';
//import Button from '@material-ui/core/Button';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import moment from 'moment';
import Modal from '@material-ui/core/Modal';

const FallingRiskModal = ({ openRisk, closeOpenRisk, caidaData, dataCaidaSet }) => {

    const [loading, setLoading] = useState(true);
    const [disable, setDisable] = useState(false);
    const [age, setAge] = useState('');

    const [caidasPrev, setCaidasPrev] = useState({ question: 'Caidas previas', options: ['Sí', 'No'], answer: '' });
    const [medicamentos, setMedicamentos] = useState({ question: 'El Paciente usa medicamentos, Tranquilizantes, sedantes, diuréticos, antidepresivoss', options: ['Sí', 'No'], answer: '' });
    const [deficits, setDeficits] = useState({ question: 'Deficits Sensoriales', options: ['Alteraciones Visuales, Auditivas', 'Ninguno'], answer: '' });
    const [mental, setMental] = useState({ question: 'Estado mental', options: ['Orientado', 'Confuso'], answer: '' });
    const [deambulacion, setDeambulacion] = useState({ question: 'El Paciente deambula normalmente de manera segura y sin ayuda ', options: ['Sí', 'No'], answer: '' });


    useEffect(() => {
        console.log(caidaData)
        validaData();
    }, []);

    const validaData = () => {
        if (caidaData.caidas != undefined) {
            setCaidasPrev({ question: 'Caidas previas', options: ['Sí', 'No'], answer: caidaData.caidas.caida_previa });
            setMedicamentos({ question: 'El Paciente usa medicamentos, Tranquilizantes, sedantes, diuréticos, antidepresivoss', options: ['Sí', 'No'], answer: caidaData.caidas.medicamentos });
            setDeficits({ question: 'Deficits Sensoriales', options: ['Alteraciones Visuales, Auditivas', 'Ninguno'], answer: caidaData.caidas.def_sensoriales });
            setMental({ question: 'Estado mental', options: ['Orientado', 'Confuso'], answer: caidaData.caidas.estado_mental });
            setDeambulacion({ question: 'El Paciente deambula normalmente de manera segura y sin ayuda ', options: ['Sí', 'No'], answer: caidaData.caidas.deambulacion });
        }
    }



    const saveFallingRisk = () => {
        let valor = 0;
        let riesgo;

        if (caidasPrev.answer === 'Sí')
            valor = valor + 1;

        if (medicamentos.answer === 'Sí')
            valor = valor + 1;

        if (deficits.answer === 'Alteraciones Visuales, Auditivas')
            valor = valor + 1;

        if (mental.answer === 'Confuso')
            valor = valor + 1;

        if (deambulacion.answer === 'No')
            valor = valor + 1;

        if (valor >= 3) {
            riesgo = "Alto";
        } else if (valor == 2) {
            riesgo = "Medio";
        } else {
            riesgo = "Bajo";
        }

        var caidas = {
            caida_previa: caidasPrev.answer,
            medicamentos: medicamentos.answer,
            def_sensoriales: deficits.answer,
            estado_mental: mental.answer,
            deambulacion: deambulacion.answer,
            valor: valor,
            riesgo: riesgo,
            fecha_hora: moment(new Date()).format("DD-MM-YYYY HH:mm:ss")
        }
        dataCaidaSet(caidas);
        return;
    }

    return (
        <Fragment>
            <Modal
                open={openRisk}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}>

                <div className="paperAppointment-default">
                    <div className="card__title">
                        <h4 className="bold-text">Determinación de riesgo de caida </h4>
                    </div>
                    <Row>
                        <div className="form" style={{ flexDirection: 'column' }}>
                            <div className="half">
                                <div>
                                    <Table style={{ height: 70, margin: 0 }}>
                                        <tbody>
                                            <tr style={{ lineHeight: 1, borderTop: '1px solid #6c757d' }}>
                                                <td style={{ padding: 9, fontSize: '1rem', fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontWeight: 400 }}>{caidasPrev.question}</td>
                                                <td style={{ padding: 2 }}>

                                                    <FormControl component="fieldset" >
                                                        <RadioGroup
                                                            aria-label="Medicamentos"
                                                            name="medicamentos"
                                                            value={caidasPrev.answer}
                                                            onChange={e => {
                                                                setCaidasPrev({ question: 'Caidas previas', options: ['Sí', 'No'], answer: e.target.value });
                                                            }}
                                                        >
                                                            <FormControlLabel value={caidasPrev.options[0]} control={<Radio color="primary" disabled={disable} />} label={caidasPrev.options[0]} />
                                                            <FormControlLabel value={caidasPrev.options[1]} control={<Radio color="primary" disabled={disable} />} label={caidasPrev.options[1]} />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </td>
                                            </tr>
                                            <tr style={{ lineHeight: 1, borderTop: '1px solid #6c757d' }}>
                                                <td style={{ padding: 9, fontSize: '1rem', fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontWeight: 400 }}>{medicamentos.question}</td>
                                                <td style={{ padding: 2 }}>

                                                    <FormControl component="fieldset" >
                                                        <RadioGroup
                                                            aria-label="Medicamentos"
                                                            name="medicamentos"
                                                            value={medicamentos.answer}
                                                            onChange={e => {
                                                                setMedicamentos({ question: 'El Paciente usa medicamentos, Tranquilizantes, sedantes, diuréticos, antidepresivoss', options: ['Sí', 'No'], answer: e.target.value });
                                                            }}
                                                        >
                                                            <FormControlLabel value={medicamentos.options[0]} control={<Radio color="primary" disabled={disable} />} label={medicamentos.options[0]} />
                                                            <FormControlLabel value={medicamentos.options[1]} control={<Radio color="primary" disabled={disable} />} label={medicamentos.options[1]} />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </td>
                                            </tr>
                                            <tr style={{ lineHeight: 1, borderTop: '1px solid #6c757d' }}>
                                                <td style={{ padding: 9, fontSize: '1rem', fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontWeight: 400 }}>{deficits.question}</td>
                                                <td style={{ padding: 2 }}>

                                                    <FormControl component="fieldset" >
                                                        <RadioGroup
                                                            aria-label="Medicamentos"
                                                            name="medicamentos"
                                                            value={deficits.answer}
                                                            onChange={e => {
                                                                setDeficits({ question: 'Deficits Sensoriales', options: ['Alteraciones Visuales, Auditivas', 'Ninguno'], answer: e.target.value });
                                                            }}
                                                        >
                                                            <FormControlLabel value={deficits.options[0]} control={<Radio color="primary" disabled={disable} />} label={deficits.options[0]} />
                                                            <FormControlLabel value={deficits.options[1]} control={<Radio color="primary" disabled={disable} />} label={deficits.options[1]} />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </td>
                                            </tr>
                                            <tr style={{ lineHeight: 1, borderTop: '1px solid #6c757d' }}>
                                                <td style={{ padding: 9, fontSize: '1rem', fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontWeight: 400 }}>{mental.question}</td>
                                                <td style={{ padding: 2 }}>

                                                    <FormControl component="fieldset" >
                                                        <RadioGroup
                                                            aria-label="Medicamentos"
                                                            name="medicamentos"
                                                            value={mental.answer}
                                                            onChange={e => {
                                                                setMental({ question: 'Estado mental', options: ['Orientado', 'Confuso'], answer: e.target.value });
                                                            }}
                                                        >
                                                            <FormControlLabel value={mental.options[0]} control={<Radio color="primary" disabled={disable} />} label={mental.options[0]} />
                                                            <FormControlLabel value={mental.options[1]} control={<Radio color="primary" disabled={disable} />} label={mental.options[1]} />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </td>
                                            </tr>
                                            <tr style={{ lineHeight: 1, borderTop: '1px solid #6c757d' }}>
                                                <td style={{ padding: 9, fontSize: '1rem', fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontWeight: 400 }}>{deambulacion.question}</td>
                                                <td style={{ padding: 2 }}>

                                                    <FormControl component="fieldset" >
                                                        <RadioGroup
                                                            aria-label="Medicamentos"
                                                            name="medicamentos"
                                                            value={deambulacion.answer}
                                                            onChange={e => {
                                                                setDeambulacion({ question: 'El Paciente deambula normalmente de manera segura y sin ayuda ', options: ['Sí', 'No'], answer: e.target.value });
                                                            }}
                                                        >
                                                            <FormControlLabel value={deambulacion.options[0]} control={<Radio color="primary" disabled={disable} />} label={deambulacion.options[0]} />
                                                            <FormControlLabel value={deambulacion.options[1]} control={<Radio color="primary" disabled={disable} />} label={deambulacion.options[1]} />
                                                        </RadioGroup>
                                                    </FormControl>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button
                                            style={{ marginTop: 10 }}
                                            color="primary"
                                            onClick={() => {
                                                closeOpenRisk();

                                            }}
                                        >
                                            Cerrar
                                        </Button>
                                        <Button
                                            color="primary"
                                            disabled={disable}
                                            style={{ marginTop: 10, marginRight: 10 }}
                                            onClick={() => {
                                                saveFallingRisk();
                                                closeOpenRisk();
                                            }}>
                                            Guardar
                                        </Button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Row>
                </div>
            </Modal>
        </Fragment>
    );




}

export default reduxForm({
    form: 'falling_risk_form', // a unique identifier for this form
})(withTranslation('common')(FallingRiskModal));